export const MillisecondsInOneDay = 86400000;
export const MillisecondsIn1Sec = 1000;
export const MillisecondsIn15Sec = 15000;
export const MillisecondsIn1Min = 60000;
export const MillisecondsIn30Mins = 1800000;
export const MillisecondsIn1Hour = 3600000;
export const MinutesInOneDay = 1440;
export const MinutesInOneHour = 60;
export const DaysInOneWeek = 7;
export const HoursInOneDay = 24;
export const MonthInOneYear = 12;
